import Layout from '../components/Layout';
import Seo from '../components/Seo';

export default function SlikFungererDet() {
  return (
    <Layout>
      <Seo title="Slik fungerer Specialists.no – Fra forespørsel til konsultasjon" description="Slik fungerer Specialists.no fra forespørsel til konsultasjon." canonical="https://specialists.no/slik-fungerer-det" />
      <section className="bg-[#0A1F44] text-white py-16 lg:py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-display text-4xl lg:text-5xl font-bold">Slik fungerer det</h1>
          <p className="text-white/70 mt-4 text-lg">Fra forespørsel til konsultasjon — hele prosessen forklart.</p>
        </div>
      </section>
      <section className="py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8 text-[#334155] leading-relaxed">
          <div>
            <div className="font-display text-5xl font-bold text-[#3B82F6]/30">01</div>
            <h2 className="font-display text-2xl font-bold text-[#0A1F44] -mt-2">Du fyller ut skjemaet</h2>
            <p>Velg by, behandling og eventuelt klinikk. Oppgi kontaktopplysninger og godkjenn samtykke-erklæringen. Tar under ett minutt.</p>
          </div>
          <div>
            <div className="font-display text-5xl font-bold text-[#3B82F6]/30">02</div>
            <h2 className="font-display text-2xl font-bold text-[#0A1F44] -mt-2">Vi videresender til klinikken</h2>
            <p>Forespørselen sendes direkte til klinikken du valgte (eller den vi foreslår). Klinikken mottar en PDF med alle detaljer.</p>
          </div>
          <div>
            <div className="font-display text-5xl font-bold text-[#3B82F6]/30">03</div>
            <h2 className="font-display text-2xl font-bold text-[#0A1F44] -mt-2">Klinikken kontakter deg</h2>
            <p>Innen 24 timer i åpningstid vil klinikken ringe deg eller sende e-post med pris, ledige timer og en individuell vurdering.</p>
          </div>
          <div>
            <div className="font-display text-5xl font-bold text-[#3B82F6]/30">04</div>
            <h2 className="font-display text-2xl font-bold text-[#0A1F44] -mt-2">Du bestemmer</h2>
            <p>Du velger selv om du vil gå videre. Ingenting er forpliktende før du aktivt booker en konsultasjon hos klinikken.</p>
          </div>
        </div>
      </section>
    </Layout>
  );
}
